import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect } from "react";
import MudaMecanizada from "..";
import FormRow from "components/form/FormRow";
import SelectInput from "components/form/input/SelectInput";
import { useCoordinates } from "util/geolocation";
import { Box } from "@mui/material";
import { useForm } from "react-final-form";

export default function EditFields({ visita, isNew, TipoClass }) {
    const [tipo] = useTipoApontamento();
    const params = visita.cliente.getParams(MudaMecanizada, tipo, TipoClass);

    const [apontamento] = useFieldValue();
    const form = useForm();
    const [coordinates] = useCoordinates();

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = MudaMecanizada.calcConformidade(apontamento, params);
            form.change("tamToletesPicados", apontamento.tamToletesPicados);
            form.change("entrenosRachados", apontamento.entrenosRachados);
            form.change("nosRachados", apontamento.nosRachados);
            form.change("gemasDanificadas", apontamento.gemasDanificadas);
            form.change("palmitoAgregado", apontamento.palmitoAgregado);

            if (isNew && !apontamento.georeferencia) {
                apontamento.georeferencia = coordinates;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, coordinates, isNew, params]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} showImplemento={false} showVariedade showCorte />

            <ApontamentoAmostraParams>
                <FormRow>
                    <SelectInput name="turno" label="Turno" options={["A", "B", "C"]} />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <FormRow>
                            <ApontamentoParamItem label="T.T.P.(%):">{params.tamToletesPicados}</ApontamentoParamItem>
                            <ApontamentoParamItem label="E.R.(%):">{params.entrenosRachados}</ApontamentoParamItem>
                            <ApontamentoParamItem label="N.R.(%):">{params.nosRachados}</ApontamentoParamItem>
                            <ApontamentoParamItem label="G.D.(%):">{params.gemasDanificadas}</ApontamentoParamItem>
                            <ApontamentoParamItem label="P.A.(%):">{params.palmitoAgregado}</ApontamentoParamItem>
                        </FormRow>
                        <FormRow>
                            <ApontamentoParamItem label="Observação: ">{params.obs}</ApontamentoParamItem>
                        </FormRow>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita} showList={false}>
                <FormRow sx={{ border: 1, borderColor: "grey.400", borderRadius: "16px", p: 2 }}>
                    <Box flexGrow={1} sx={{ ml: 2, display: "flex", alignItems: "center" }}>
                        Tamanho dos Toletes Picados
                    </Box>
                    <Box sx={{ display: "flex" }}>
                        <TextInput
                            type="number"
                            name="totalAvaliadoTamToletesPicados"
                            label="Avaliado"
                            sx={{ mr: 2 }}
                        />
                        <TextInput
                            type="number"
                            name="totalConformeTamToletesPicados"
                            label="Conforme"
                            sx={{ mr: 2 }}
                        />
                        <TextInput type="number" name="tamToletesPicados" label="%" disabled />
                    </Box>
                </FormRow>
                <FormRow sx={{ border: 1, borderColor: "grey.400", borderRadius: "16px", p: 2 }}>
                    <Box flexGrow={1} sx={{ ml: 2, display: "flex", alignItems: "center" }}>
                        Entrenós Rachados
                    </Box>
                    <Box sx={{ display: "flex" }}>
                        <TextInput type="number" name="totalAvaliadoEntrenosRachados" label="Avaliado" sx={{ mr: 2 }} />
                        <TextInput type="number" name="totalConformeEntrenosRachados" label="Conforme" sx={{ mr: 2 }} />
                        <TextInput type="number" name="entrenosRachados" label="%" disabled />
                    </Box>
                </FormRow>
                <FormRow sx={{ border: 1, borderColor: "grey.400", borderRadius: "16px", p: 2 }}>
                    <Box flexGrow={1} sx={{ ml: 2, display: "flex", alignItems: "center" }}>
                        Nós Rachados
                    </Box>
                    <Box sx={{ display: "flex" }}>
                        <TextInput type="number" name="totalAvaliadoNosRachados" label="Avaliado" sx={{ mr: 2 }} />
                        <TextInput type="number" name="totalConformeNosRachados" label="Conforme" sx={{ mr: 2 }} />
                        <TextInput type="number" name="nosRachados" label="%" disabled />
                    </Box>
                </FormRow>
                <FormRow sx={{ border: 1, borderColor: "grey.400", borderRadius: "16px", p: 2 }}>
                    <Box flexGrow={1} sx={{ ml: 2, display: "flex", alignItems: "center" }}>
                        Gemas Danificadas
                    </Box>
                    <Box sx={{ display: "flex" }}>
                        <TextInput type="number" name="totalAvaliadoGemasDanificadas" label="Avaliado" sx={{ mr: 2 }} />
                        <TextInput type="number" name="totalConformeGemasDanificadas" label="Conforme" sx={{ mr: 2 }} />
                        <TextInput type="number" name="gemasDanificadas" label="%" disabled />
                    </Box>
                </FormRow>
                <FormRow sx={{ border: 1, borderColor: "grey.400", borderRadius: "16px", p: 2 }}>
                    <Box flexGrow={1} sx={{ ml: 2, display: "flex", alignItems: "center" }}>
                        Palmito Agregado
                    </Box>
                    <Box sx={{ display: "flex" }}>
                        <TextInput type="number" name="totalAvaliadoPalmitoAgregado" label="Avaliado" sx={{ mr: 2 }} />
                        <TextInput type="number" name="totalConformePalmitoAgregado" label="Conforme" sx={{ mr: 2 }} />
                        <TextInput type="number" name="palmitoAgregado" label="%" disabled />
                    </Box>
                </FormRow>
            </ApontamentoColetas>

            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
